if (!customElements.get('video-modal')) {
  customElements.define(
    'video-modal',
    class VideoModal extends HTMLElement {
      constructor() {
        super();
        this.modalId = this.dataset.modalId;
        this.originalSrc = null;
        this.modal = this.querySelector('.modal-trigger');
        this.closeBtn = this.querySelector('.video-modal-close');
        this.overlay = this.querySelector('.video-modal-overlay');
        this.video = this.querySelector('.modal-content video, .modal-content iframe');
        this.videoElement = this.querySelector('video-element');

        this.scrollY = 0;
      }

      connectedCallback() {
        // ✅ FIX 1: pass event
        document.addEventListener('modalOpen', (e) => this.open(e));

        this.closeBtn?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
      }

      lockScroll() {
        this.scrollY = window.scrollY;
        document.body.classList.add('modal-open');
        document.body.style.top = `-${this.scrollY}px`;
      }

      unlockScroll() {
        document.body.classList.remove('modal-open');
        document.body.style.top = '';
        window.scrollTo(0, this.scrollY);
      }

      open(e) {

        const modalId = e?.detail?.modalId;

        // ✅ FIX 2: correct condition
        if (modalId !== this.modalId) return;

        this.modal.classList.remove('hidden');
        this.modal.classList.add('is-active');
        this.lockScroll();

        if (this.video) {
          if (this.video.tagName === 'VIDEO') {
            this.videoElement.setAttribute('loaded', 'true');
            this.video.muted = false;
            this.video.play();
            console.log('play video');
          }

          if (this.video.tagName === 'IFRAME') {
            this.videoElement.setAttribute('loaded', 'true');

            if (!this.originalSrc) {
              this.originalSrc = this.video.src;
            }

            if (!this.video.src.includes('autoplay')) {
              this.video.src =
                this.originalSrc +
                (this.originalSrc.includes('?') ? '&' : '?') +
                'autoplay=1';
            }
          }
        } else {
        }
      }

      close() {
        this.modal.classList.add('hidden');
        this.modal.classList.remove('is-active');
        this.unlockScroll();

        if (this.video) {
          if (this.video.tagName === 'VIDEO') {
            this.videoElement.classList.remove('loaded');
            this.video.pause();
            this.video.currentTime = 0;
          }

          if (this.video.tagName === 'IFRAME') {
            this.videoElement.classList.remove('loaded');
            this.video.src = this.originalSrc;
          }
        }
      }
    }
  );
}

